import React, { Component } from 'react';
import { connect } from "react-redux";
import GuildsMenu from 'components/guilds/GuildsMenu.js';
import TransactionsView from 'components/toolbar/TransactionsView';
import LoginModal from 'components/modals/LoginModal.js';
import '../navigator.scss';

class UniversalNavigator extends Component {
    onClickSequencer() {
        window.location = '/create/';
    }

    onClickSampler() {
        if (this.props.view !== 'DISCOVER') {
            window.location = '/discover/';
        }
    }

    onClickExplore() {
        if (this.props.view !== 'EXPLORE') {
            window.location = '/explore/';
        }
    }

    onClickLogo() {
        window.location = '/';
    }

    render() {
        let view = this.props.view || '';
        let samplerClassName = view === 'DISCOVER' ? 'navigator-button selected' : 'navigator-button';
        let exploreClassName = view === 'EXPLORE' ? 'navigator-button selected' : 'navigator-button';
        return (
            <div className="navigator">
              <LoginModal show={this.props.showLogin}/>
              <div onClick={()=>this.onClickLogo()} className={"universal-sequences-logo " + view}>
                ZEQUENCER
              </div>
              <div onClick={() => this.onClickSequencer()} className="navigator-button">
                CREATE
              </div>
              <div onClick={() => this.onClickExplore()} className={exploreClassName}>
                EXPLORE
              </div>
              <div onClick={() => this.onClickSampler()} className={samplerClassName}>
                SAMPLE 
              </div>
              <div className="guilds-menu-container">
                <TransactionsView store={this.props.store}/>
                <GuildsMenu store={this.props.store}/>
              </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        showLogin: state.sequencer.showLogin,
    }
};

export default connect(mapStateToProps, null)(UniversalNavigator);
